var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09606 23.6434C15.5262 25.2467 22.0381 21.3339 23.6409 14.9045H23.6409L23.6408 14.9046C25.2438 8.475 21.3313 1.96199 14.9016 0.359121C8.47348 -1.24375 1.96159 2.66933 0.359423 9.09939C-1.24415 15.5282 2.66863 22.0405 9.09606 23.6434ZM12.0193 12.9572C13.0671 12.9572 13.5368 12.9292 13.6277 12.9223L13.6247 12.9216C16.8392 12.7792 19.2371 12.2185 19.2371 11.5488C19.2371 10.8791 16.8385 10.3184 13.6247 10.1752V12.3647C13.5345 12.3731 13.0338 12.4147 12.0337 12.4147C11.2003 12.4147 10.5973 12.3791 10.3867 12.364V10.1737C7.16606 10.3177 4.76216 10.8776 4.76216 11.5488C4.76216 12.22 7.16606 12.7807 10.3867 12.9223C10.5943 12.9322 11.1859 12.9572 12.0193 12.9572ZM13.6277 9.948V9.94872L13.627 9.94796C13.6272 9.94797 13.6275 9.94799 13.6277 9.948ZM13.6277 7.98878V9.948C17.2662 10.1163 20 10.8375 20 11.7018C20 12.5663 17.2635 13.2875 13.627 13.4549V19.7378H10.3859V13.4572C6.74104 13.289 4 12.5678 4 11.7026C4 10.8374 6.74104 10.1154 10.3859 9.94796V7.98878H5.90161V5H18.1128V7.98878H13.6277Z",
    fill: "url(#paint0_linear_163_697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_697",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B266F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.8c59c76ffba4addd221c45d13b5505cb.svg";
export { ForwardRef as ReactComponent };